import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ElementRenderer } from './ElementRenderer';
import { LeafRenderer } from './LeafRenderer';
export const renderChildren = (children, options) => {
    if (!Array.isArray(children)) {
        children = [children];
    }
    return (_jsx(_Fragment, { children: children.map((child, i) => {
            if ('text' in child) {
                return _jsx(LeafRenderer, { leaf: child, renderLeaf: options.renderLeaf }, i);
            }
            if ('children' in child) {
                return (_jsx(ElementRenderer, Object.assign({ element: child, options: options }, { children: renderChildren(child.children, options) }), i));
            }
            return null; // Throw?
        }) }, void 0));
};
//# sourceMappingURL=renderChildren.js.map